import { ServiceIcon } from '@/components/ui/ServiceIcon'
import type { ServiceId } from '@/content/services'

const DECK_MODULES: readonly ServiceId[] = [
  'crm',
  'communication',
  'marketing',
  'loyalty',
  'api',
  'analytics',
]

const CHART_BARS = [38, 54, 46, 70, 62, 84, 76]

export function HeroDeck() {
  return (
    <div className="hero__deck" aria-hidden="true">
      <div className="deck">
        <div className="deck__panel deck__panel--back" />
        <div className="deck__panel deck__panel--mid" />
        <div className="deck__panel deck__panel--front">
          <div className="deck__bar">
            <span />
            <span />
            <span />
            <span className="deck__bar-title" />
          </div>
          <div className="deck__tiles">
            {DECK_MODULES.map((id, index) => (
              <div className="deck__tile" key={id} style={{ '--tile-index': index }}>
                <ServiceIcon id={id} size={30} />
                <span className="deck__line" />
                <span className="deck__line deck__line--short" />
              </div>
            ))}
          </div>
          <div className="deck__chart">
            {CHART_BARS.map((height, index) => (
              <span
                className="deck__chart-bar"
                key={height}
                style={{ '--bar-height': `${height}%`, '--bar-index': index }}
              />
            ))}
          </div>
        </div>
        <div className="deck__badge">
          <span className="deck__badge-dot" />
          <span className="deck__line" />
          <span className="deck__line deck__line--short" />
        </div>
      </div>
    </div>
  )
}
